import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";
import moment from "moment";

export const assetDetailsByFilterTodo = createAsyncThunk("assetDetailsByFilter", async ({ data, navigate }) => {

    try {
        const res = await axios({
            method: "GET",
            url: process.env.REACT_APP_API_URL + "asset_details_by_filter",
            params: {
                category_id: data?.categoryId,
                sub_cat_id: data?.subCategoryId,
                item_master_id: data?.itemId,
                vendor_id: data?.vendorId,
                invoice_date: data?.invoiceDate && moment(data?.invoiceDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: SessionManager.getSession("user_token"),
            },
        });
        return res;
    } catch (error) {
        return error.response;
    }
}
);

const assetDetailsByFilterSlice = createSlice({
    name: "assetDetailsByFilter",
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(assetDetailsByFilterTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data?.data || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate);
            } else {
                state.data = [];
            }
        });
        builder.addCase(assetDetailsByFilterTodo.rejected, () => {
            // do nothing
        });
    },
});

export default assetDetailsByFilterSlice.reducer;
